__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "AustinEhsInspections";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@amzn/austin-core", "2.143.0", function() { return Promise.all([__webpack_require__.e(3801), __webpack_require__.e(5049), __webpack_require__.e(9459), __webpack_require__.e(5482), __webpack_require__.e(4952), __webpack_require__.e(4717), __webpack_require__.e(9587), __webpack_require__.e(1339), __webpack_require__.e(1614), __webpack_require__.e(2275), __webpack_require__.e(7380), __webpack_require__.e(2226), __webpack_require__.e(5520), __webpack_require__.e(4060), __webpack_require__.e(6389), __webpack_require__.e(6817), __webpack_require__.e(3438), __webpack_require__.e(6176), __webpack_require__.e(1287), __webpack_require__.e(9020), __webpack_require__.e(6552)]).then(function() { return function() { return __webpack_require__("../node_modules/@amzn/austin-core/dist/index.js"); }; }); });
			register("react-dom", "18.2.0", function() { return Promise.all([__webpack_require__.e(1542), __webpack_require__.e(1287)]).then(function() { return function() { return __webpack_require__("../node_modules/react-dom/index.js"); }; }); });
			register("react-router-6", "6.30.0", function() { return Promise.all([__webpack_require__.e(6403), __webpack_require__.e(4935), __webpack_require__.e(1287)]).then(function() { return function() { return __webpack_require__("../node_modules/react-router/dist/index.js"); }; }); });
			register("react-router-dom", "6.30.0", function() { return Promise.all([__webpack_require__.e(6403), __webpack_require__.e(5783), __webpack_require__.e(6176), __webpack_require__.e(1287), __webpack_require__.e(7736)]).then(function() { return function() { return __webpack_require__("../node_modules/react-router-dom/dist/index.js"); }; }); });
			register("react", "18.2.0", function() { return __webpack_require__.e(7378).then(function() { return function() { return __webpack_require__("../node_modules/react/index.js"); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};